export const fsaReports = {
  prefix: 'fsa',
  iconName: 'fsaReports',
  icon: [
    213,
    256,
    [],
    null,
    [
      'M165.61334,47.20184v14.82623H46.50275V47.20184H165.61334z M46.50275,98.91101h119' +
        '.1106V84.08478   H46.50275V98.91101z M46.50275,135.39746h80.08868v-14.82623H46.5' +
        '0275V135.39746z',
      'M212.07434,0H0v170.45453l85.55591,85.50378h1.61731L87.2149,256v-0.04169h124.8594' +
        '4V0z    M36.36127,184.19568h36.01697v36.00647L36.36127,184.19568z M197.24811,241' +
        '.13208H91.69092l-4.47601-4.47601V169.4007   l-0.02087-0.03125H19.92822l-5.0603-5' +
        '.0603V14.82623h182.38019V241.13208z',
    ],
  ],
};
